export function daysToMs(day: number) {
  return day * 24 * 60 * 60 * 100;
}
